angular.module('FlexyBeautyApp.services').factory('BillingManager_Resource', [
    "$resource", "$location",
    function ($resource,$location) {
        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + 'rest/billing-manager', {}, {
            getBillingManager: {method: 'GET', url: baseUrl + 'rest/billing-manager'},
            computeSiteName: {method: 'GET', url: baseUrl + 'rest/billing-manager/site-name'},
            createPortalSession: {method: 'POST', url: baseUrl + 'rest/billing-manager/create-portal-session'},
        });
    }
]);

angular.module('FlexyBeautyApp.services').factory('BillingManagerSrv', ['BillingManager_Resource',
    function (BillingManager_Resource) {
        let billingManagerSrv = {};

        billingManagerSrv.getBillingManager = function () {
            return BillingManager_Resource.getBillingManager().$promise;
        }

        billingManagerSrv.computeSiteName = function () {
            return BillingManager_Resource.computeSiteName().$promise;
        }

        billingManagerSrv.createPortalSession = function () {
            return BillingManager_Resource.createPortalSession().$promise;
        }

        return billingManagerSrv;
    }
]);




// WEBPACK FOOTER //
// ./js/services/models/BillingManager.js